if (!customElements.get("supercycle-bundle-block")) {
  class SupercycleBundleBlock extends HTMLElement {
    constructor() {
      super();
      this.bundleIds = this.dataset.bundleIds;
      this.productEls = this.querySelector('.supercycle_bundle__products');
      this.formEl = this.querySelector(".supercycle_bundle__form");
      this.formSubmitEl = this.formEl.querySelector("button[type='submit']");
      this.durationSelectEl = this.querySelector("[data-duration]");
      this.startDateEl = this.querySelector("[data-start-date]");
      this.endDateEl = this.querySelector("[data-end-date]");

      this.startDateButtonEl = this.querySelector('[data-date-type="start"]');
      this.endDateButtonEl = this.querySelector('[data-date-type="end"]');
      
      this.pricePerDayEl = this.querySelector("[data-price-per-day]");
      this.totalPriceEl = document.querySelector(".sc-method-price .price");
      this.optionErrorEl = this.querySelector('.supercycle_bundle__product-option-error--options');
      this.unavailableErrorEl = this.querySelector('.supercycle_bundle__product-option-error--unavailable');
      this.quantityErrorEl = this.querySelector('.supercycle_bundle__product-option-error--quantity');
      this.productProtectionInputEl = this.querySelector('#product-protection');
      this.datePickerModal = this.querySelector('.supercycle_bundle__date-modal');
      this.datePickerModalOverlay = this.querySelector('.supercycle_bundle__date-modal--overlay');
      this.datePickerModalCalendarArea = this.datePickerModal.querySelector('.date-modal__calendar');
      this.datePickerModalClearEl = this.querySelector('#date-modal__clear');
      this.datePickerModalCloseEl = this.querySelector('#date-modal__close');
      this.datePickerRangeSelectEl = this.querySelector('.date-modal__footer-period');
      this.openDateModalEls = this.querySelectorAll('.open-date-modal');
      this.unavailableDates = this.parseUnavailableDates(this.dataset.unavailableDates);
      
      this.allPrices = this.querySelector(".all-supercycle-prices");
      this.prices = JSON.parse(this.allPrices.dataset.prices);
    }

    connectedCallback() {
      this.bundleBlockInit();
    }

    getTotalForDuration(prices, duration, perDay) {
      let total = 0;
      for (const product in prices) {
        if (prices.hasOwnProperty(product)) {
          const productPrices = prices[product];
          if (productPrices && productPrices[duration] !== undefined) {
            total += productPrices[duration];
          }
        }
      }
      if (perDay) {
        total = total / duration;
      }
      const currency = Shopify.currency.active;
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: currency,
        currencyDisplay: "narrowSymbol"
      }).format(total / 100);
    }

    // Gets set in the customiser as unavailable
    parseUnavailableDates(value) {
      if (!value) return [];
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch (error) {
        console.warn("Unavailable dates has invalid JSON:", error);
        return [];
      }
    }

    // Prevent users using the duration onption to bypass the unavailable dates: start
    normaliseDate(date) {
      const normalisedDate = new Date(date);
      normalisedDate.setHours(0, 0, 0, 0);
      return normalisedDate;
    }
    isUnavailableDate(date) {
      const checkDate = this.normaliseDate(date);
      return this.unavailableDates.some((unavailableDate) => {
        if (!unavailableDate) return false;
        if (typeof unavailableDate === "string") {
          return checkDate.getTime() === this.normaliseDate(unavailableDate).getTime();
        }

        if (unavailableDate.from || unavailableDate.to) {
          const fromDate = unavailableDate.from ? this.normaliseDate(unavailableDate.from) : null;
          const toDate = unavailableDate.to ? this.normaliseDate(unavailableDate.to) : null;
          if (fromDate && toDate) {
            return checkDate >= fromDate && checkDate <= toDate;
          }
          if (fromDate) {
            return checkDate >= fromDate;
          }
          if (toDate) {
            return checkDate <= toDate;
          }
        }
        return false;
      });
    }
    rangeContainsUnavailableDate(startDate, endDate) {
      const currentDate = this.normaliseDate(startDate);
      const lastDate = this.normaliseDate(endDate);
      while (currentDate <= lastDate) {
        if (this.isUnavailableDate(currentDate)) {
          return true;
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return false;
    }
    // Prevent users using the duration onption to bypass the unavailable dates: end
    
    bundleBlockInit() {
      this.productEls.querySelectorAll(".supercycle_bundle__product-options").forEach((fieldset) => {
        const variantSelects = fieldset.querySelectorAll(".supercycle_bundle__product-option select");
        variantSelects.forEach((variantInput) => {
          variantInput.addEventListener("change", this.updateProductOptions, false);
        });
      });

      this.openDateModalEls.forEach((opener) => {
        opener.addEventListener("click", this.openDatePickerModal.bind(this));
      });
      this.datePickerModalCloseEl.addEventListener("click", this.closeDatePickerModal.bind(this));
      this.datePickerModalOverlay.addEventListener("click", this.closeDatePickerModal.bind(this));

      this.durationSelectEl.addEventListener("change", this.durationChange.bind(this));
      this.datePickerRangeSelectEl.addEventListener("change", this.datePickerDurationChange.bind(this));
      this.startDateEl.addEventListener("change", this.startDateChange.bind(this));
      this.formSubmitEl.addEventListener("click", this.formSubmit.bind(this));

      const endPicker = flatpickr(this.endDateEl, {
        dateFormat: "Y-m-d",
        altInput: true,
      });

      const startPicker = flatpickr(this.startDateEl, {
        appendTo: this.datePickerModalCalendarArea,
        inline: true,
        mode: "range",
        minDate: new Date(),
        showMonths: 2,
        altInput: true,
        dateFormat: "Y-m-d",
        disable: this.unavailableDates,
        locale: {
          weekdays: {
            shorthand: ["S", "M", "T", "W", "T", "F", "S"],
            longhand: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
          }
        },
        onChange: function(selectedDates, dateStr, instance) {
          const summaryPeriod = document.querySelector('select[data-duration]');
          const footerPeriod = document.querySelector('.date-modal__footer-period');

          if (selectedDates.length == 1) {
            const maxDays = parseInt(footerPeriod.options[footerPeriod.options.length - 1].dataset.durationCount) - 1;
            let newEndDate = new Date(selectedDates[0]);
            newEndDate.setDate(newEndDate.getDate() + maxDays);
            // Set the end date
            startPicker.set('maxDate', newEndDate);
          }
          if (selectedDates.length > 1) {
            // get number of days from range
            const dateStart = new Date(selectedDates[0]);
            const dateEnd = new Date(selectedDates[1]);
            const timeDifference = dateEnd.getTime() - dateStart.getTime();
            const days = 1 + Math.round((timeDifference / (1000 * 3600 * 24)));

            // update footer and summary selects to number of days                        
            if(footerPeriod.querySelector('[data-duration-count="' + days + '"]')) {
              const periodOptionIndex = footerPeriod.querySelector('[data-duration-count="' + days + '"]').index;
              summaryPeriod.selectedIndex = periodOptionIndex;
              footerPeriod.selectedIndex = periodOptionIndex;
              summaryPeriod.dispatchEvent(new Event('change'));

              // update inputs
              document.querySelector("[data-start-date]").value = selectedDates[0];
              document.querySelector("[data-end-date]").value = selectedDates[1];
            
              // Update placeholder date buttons
              const formattedStartDate = new Date(selectedDates[0]).toLocaleDateString('en-GB', { day:"numeric", month:"short", year:"2-digit"});
              const formattedEndDate = new Date(selectedDates[1]).toLocaleDateString('en-GB', { day:"numeric", month:"short", year:"2-digit"});
              document.querySelector('[data-date-type="start"]').innerHTML = formattedStartDate;
              document.querySelector('[data-date-type="end"]').innerHTML = formattedEndDate;
              document.querySelector('[data-date-type="start"]').classList.remove("empty");
              document.querySelector('[data-date-type="end"]').classList.remove("empty");
            }
          }
        }
      });
      this.datePickerModalClearEl.addEventListener("click", function (e) {
        startPicker.clear();
        startPicker.set('maxDate', false);
        document.querySelector('[data-date-type="start"]').classList.add("empty");
        document.querySelector('[data-date-type="end"]').classList.add("empty");
        document.querySelector('[data-date-type="start"]').innerHTML = "Add date";
        document.querySelector('[data-date-type="end"]').innerHTML = "Add date";
      });
    }

    openDatePickerModal() {
      this.datePickerModal.classList.add('open');
    }

    closeDatePickerModal() {
      this.datePickerModal.classList.remove('open');
    }

    // Duration change in datePicker
    datePickerDurationChange(event) {
      // change summary range select
      this.durationSelectEl.selectedIndex = event.target.selectedIndex;
      this.durationSelectEl.dispatchEvent(new Event('change'));
    }

    // Duration change in rental summary
    durationChange(event) {
      this.unavailableErrorEl.classList.remove('visible');

      // Update price
      const periodCount = String(event.target.options[event.target.selectedIndex].dataset.durationCount);
      const totalPrice = this.getTotalForDuration(this.prices, periodCount, false);
      const pricePerDay = this.getTotalForDuration(this.prices, periodCount, true);
      
      // Update selling plan IDs
      const productGlobalIds = this.productEls.querySelectorAll('.supercycle_bundle__product');
      productGlobalIds.forEach((productGlobalId) => {
        const productGlobalIdCalendarText = productGlobalId.querySelector('.supercycle_bundle__calendar-json').textContent.replaceAll("=>",":");
        const productGlobalIdCalendarJson = JSON.parse(productGlobalIdCalendarText);
        const selectedRentalPeriod = productGlobalIdCalendarJson.rental_periods.filter(obj => {
          return obj.name === event.target.options[event.target.selectedIndex].value;
        });
        productGlobalId.dataset.globalId = selectedRentalPeriod[0].global_id;
      });

      // Update total price
      this.totalPriceEl.innerHTML = totalPrice;
      // Update price per day in summary
      this.pricePerDayEl.innerHTML = pricePerDay;
      
      // change modal range select
      this.datePickerRangeSelectEl.selectedIndex = event.target.selectedIndex;
      
      // amend end date
      if(this.startDateEl.value != "") {
        const startDate = new Date(this.startDateEl.value);
        const endDate = new Date(this.startDateEl.value);
        endDate.setDate(endDate.getDate() + this.getSelectedDuration());
        // Reset dates if duration change includes excluded dates
        if (this.rangeContainsUnavailableDate(startDate, endDate)) {
          this.startDateEl._flatpickr?.clear();
          this.startDateEl._flatpickr?.set("maxDate", false);
          this.startDateEl.value = "";
          this.endDateEl.value = "";
          this.startDateButtonEl.innerHTML = "Add date";
          this.endDateButtonEl.innerHTML = "Add date";
          this.startDateButtonEl.classList.add("empty");
          this.endDateButtonEl.classList.add("empty");
          return;
        }

        const endYear = endDate.getFullYear();
        const endMonth = ("0" + (endDate.getMonth() + 1)).slice(-2);
        const endDay = ("0" + endDate.getDate()).slice(-2);
        this.endDateEl.value = endYear + "-" + endMonth + "-" + endDay;
        const rentalEndText = new Date(this.endDateEl.value).toLocaleDateString('en-GB', { day:"numeric", month:"short", year:"2-digit"});
        this.endDateButtonEl.innerHTML = rentalEndText;
      }
    }

    // Submit form
    async formSubmit(event) {
      event.preventDefault();
      this.formSubmitEl.disabled = true;
      this.unavailableErrorEl.classList.remove('visible');
      
      // check all options are selected
      if(this.optionCheck()) {
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
        // check rental availability and add rental intent tokens
        try {
          if (await this.availabilityCheck()) {
            // Submit
            await this.addToCart(event);
          } else {
            // Options are not available
            document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
            this.formSubmitEl.disabled = false;
          }
        } 
        catch(e) {
          // Error checking availability
          document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
          this.formSubmitEl.disabled = false;
        }
      } else {
        this.formSubmitEl.disabled = false;
      }
    }

    // Get subproduct variant IDs
    updateProductOptions(event) {
      const productGroup = event.target.closest('.supercycle_bundle__product');
      const productVariantOptions = JSON.parse(productGroup.querySelector('.supercycle_bundle__product-options').dataset.productOptions);

      // clear errors on change
      productGroup.classList.remove('supercycle_bundle__product--unavailable');
      document.querySelector('.supercycle_bundle__product-option-error--unavailable').classList.remove('visible');
      productGroup.querySelector('.supercycle_bundle__product-quantity-error').classList.remove('visible');

      if (event.target.value != "") {
        event.target.classList.remove('select-empty');
      }

      // Get selected options
      const selectedOptions = ["", "", ""];
      let productVariantOptionIndex = 0;
      productGroup.querySelectorAll(".supercycle_bundle__product-option").forEach((options) => {
        options.querySelectorAll("select").forEach((select) => {
          if (select.value != "") {
            selectedOptions[productVariantOptionIndex] = select.value;
          }
        });
        productVariantOptionIndex++;
      });

      // Disable invalid options
      const selects = productGroup.querySelectorAll('.supercycle_bundle__product-option select');
      selects.forEach((select, selectIndex) => {
        select.querySelectorAll('option').forEach((option) => {
          if (option.value === '') return;
          const testOptions = [...selectedOptions];
          testOptions[selectIndex] = option.value;
          const matchingVariant = productVariantOptions.find((variant) => {
            return (
              (!testOptions[0] || variant.option1 === testOptions[0]) &&
              (!testOptions[1] || variant.option2 === testOptions[1]) &&
              (!testOptions[2] || variant.option3 === testOptions[2])
            );
          });
          option.disabled = !matchingVariant;
        });
      });

      // Get selected variant from selected options
      const selectedOption = productVariantOptions.filter(
        (item) =>
          item.option1 === selectedOptions[0] &&
          item.option2 === selectedOptions[1] &&
          item.option3 === selectedOptions[2]
      );

      // If the selected options provide a match, update subproduct variant ID input
      if (selectedOption.length) {
        productGroup.dataset.variantId = selectedOption[0]["id"];
      }
    }

    getSelectedDuration() {
      return parseInt(this.durationSelectEl.options[this.durationSelectEl.selectedIndex].dataset.durationCount) - 1;
    }

    // Changing the start date
    startDateChange(event) {
      const endDate = new Date(event.target.value);
      endDate.setDate(endDate.getDate() + this.getSelectedDuration());

      const endYear = endDate.getFullYear();
      const endMonth = ("0" + (endDate.getMonth() + 1)).slice(-2);
      const endDay = ("0" + endDate.getDate()).slice(-2);

      this.endDateEl.value = endYear + "-" + endMonth + "-" + endDay;
      this.startDateButtonEl.classList.remove('select-empty');
    }

    // Check all options have been selected
    optionCheck() {
      if(this.productEls) {
        const selectOptionEls = this.productEls.querySelectorAll(".supercycle_bundle__product select");
        let selectedAllOptions = true;
        selectOptionEls.forEach((selectOptionEl) => {
          if (selectOptionEl.value == "") {
            selectOptionEl.classList.add('select-empty');
            selectedAllOptions = false;
          }
        });

        if (this.startDateEl.value == "") {
          selectedAllOptions = false;
          this.startDateButtonEl.classList.add('select-empty');
        }

        if (selectedAllOptions) {
          this.optionErrorEl.classList.remove('visible');
          this.quantityErrorEl.classList.remove('visible');
          return true;
        } else {
          this.optionErrorEl.classList.add('visible');
          return false;
        }
      } else {
        return false;
      }
    }

    // Check availablility
    async availabilityCheck() {
      const subProductIds = this.bundleIds.split(",");
      const startDate = this.startDateEl.value;
      const endDate = this.endDateEl.value;
      const options = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          productIds: subProductIds,
          rentalStart: startDate,
          rentalEnd: endDate,  
        })
      };
      const productAvailabilityChecks = await fetch("/apps/supercycle/product_availability_checks", options);
      const res = await productAvailabilityChecks.json();
      let rentalAvailable = true;
      // for each bundle subproduct...
      for (let spi = 0; spi < subProductIds.length; spi++) {
        let hasVariant = false;
        const currentBundleProduct = document.querySelectorAll(".supercycle_bundle__product")[spi];
        // ... check through the returned available dates...
        for (let i = 0; i < res.products.length; i++) {
          const availableOptions = res.products[i].availableVariants;
          const result = availableOptions.find(({ shopifyId }) => shopifyId == currentBundleProduct.dataset.variantId);
          if (result) {
            hasVariant = true;
            break;
          } else {
            continue;
          }
        }
        // ... if found, it's available
        if (hasVariant) {
          // remove error states from subproduct
          currentBundleProduct.classList.remove("supercycle_bundle__product--unavailable");         
        } else {
          // show error states on subproduct
          currentBundleProduct.classList.add("supercycle_bundle__product--unavailable");
          rentalAvailable = false;
        }
      }
      if (rentalAvailable) {
        // remove generic error message
        this.unavailableErrorEl.classList.remove('visible');
      } else {
        // show generic error message
        this.unavailableErrorEl.classList.add('visible');
        document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      } 
      return rentalAvailable;
    }

    // Create rental intent token
    async createIntent(variantId, optionGlobalId, rentalStart) {
      return fetch("/apps/supercycle/intents", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          variantId,
          option: {
            globalId: optionGlobalId,
            params: { rentalStart },
          },
        }),
      }).then((res) => res.json());
    }

    // check for existing variants in the cart
    async getCartItemByVariant(variantId) {
      const cart = await fetch('/cart.js').then(res => res.json());
      return cart.items.find(item => item.variant_id === Number(variantId)) || null;
    }

    // Add to cart
    async addToCart() {
      const components = [];
      const bundleProducts = this.productEls.querySelectorAll(".supercycle_bundle__product");
      bundleProducts.forEach((product) => {
        const componentObj = {};
        componentObj["variantId"] = product.dataset.variantId;;
        componentObj["optionGlobalId"] = product.dataset.globalId;
        componentObj["quantity"] = product.dataset.quantity;
        components.push(componentObj);
      });

      const rentalStart = this.startDateEl.value;
      const rentalEnd = this.endDateEl.value;

      const rentalStartText = new Date(rentalStart).toLocaleDateString('en-GB', { day:"numeric", month:"short", year:"2-digit"});
      const rentalEndText = new Date(rentalEnd).toLocaleDateString('en-GB', { day:"numeric", month:"short", year:"2-digit"});

      const formData = new FormData();
      let passedQuantityCheck = true;

      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      formData.set("sections", sectionsToBundle.join(","));
      formData.set("sections_url", `${Shopify.routes.root}variants/${this.formEl.id.value}`);

      await Promise.all(
        components.map(async ({ variantId, optionGlobalId, quantity }, index) => {
          const intent = await this.createIntent(variantId, optionGlobalId, rentalStart);

          // Get the max quantity
          const validations = JSON.parse(intent.attributes["properties[_validations]"]);
          const maxQuantity = validations.quantity.max;

          const item = await this.getCartItemByVariant(variantId);
          if (item) {
            if (item.quantity >= maxQuantity) {
              this.quantityErrorEl.classList.add('visible');
              this.productEls.querySelector('[data-variant-id="' + variantId + '"] .supercycle_bundle__product-quantity-error').classList.add('visible')
              passedQuantityCheck = false;
            }
          }         

          formData.set(`items[${index}][id]`, variantId);
          formData.set(`items[${index}][quantity]`, quantity);
          formData.set(`items[${index}][properties][Start date]`, rentalStartText);
          formData.set(`items[${index}][properties][End date]`, rentalEndText);

          Object.entries(intent.attributes).forEach(([key, value]) => {
            formData.set(`items[${index}][${key}]`, value);
          });
        }),
      );

      if (!passedQuantityCheck) {
        this.formSubmitEl.disabled = false;
        return;
      }

      // protection plan product
      if (this.productProtectionInputEl) {
        if (this.productProtectionInputEl.checked) {
          const protectionIndex = bundleProducts.length;
          formData.set(`items[${protectionIndex}][id]`, this.productProtectionInputEl.value);
          formData.set(`items[${protectionIndex}][quantity]`, 1);
          formData.set(`items[${protectionIndex}][properties][Start date]`, rentalStartText);
          formData.set(`items[${protectionIndex}][properties][End date]`, rentalEndText);
        }
      }
      
      const response = await fetch("/cart/add.js", { method: "POST", body: formData });
      const responseJson = await response.json();
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      
      if (response.ok) {
        if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
          return window.location.href = `${Shopify.routes.root}cart`;
        }

        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent["sections"] = responseJson["sections"];

        this.formEl.dispatchEvent(new CustomEvent("variant:add", {
          bubbles: true,
          detail: {
            items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
            cart: cartContent,
            onSuccessDo: formData.get("on_success")
          }
        }));

        document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            onSuccessDo: formData.get("on_success"),
            cart: cartContent
          }
        }));
      } else {
        this.formEl.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: responseJson["description"]
          }
        }));
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }
      this.formSubmitEl.disabled = false;
    }
  }


  customElements.define("supercycle-bundle-block", SupercycleBundleBlock);
}
